
import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Nav, Card } from "react-bootstrap";
import { ExclamationTriangleFill } from "react-bootstrap-icons";
import { Tabs, Tab } from "react-bootstrap";
import { Row, Col } from "react-bootstrap";
import AudioDescriptionEdit from "../components/AudioDescriptionEdit";
import "../css/main.css";

const AudioRedescribeVideo = ({
   videoname, setVideoname,
  video,
  originalVideoUrl,
  activeTab,
  // setActiveTab,
  videoRef,
  //isExpert ,
}) => {
  const descriptionRef = useRef(null);
  const audioRef = useRef(null);
const isPlayingAd = useRef(false);
const isUserPlaying = useRef(false);
  const [editingIndex, setEditingIndex] = React.useState(null);
const [editedText, setEditedText] = React.useState("");
const BASE_URL = "https://ccvai.chalachitravaachana.org";
const isUserInteracted = useRef(false);
const cancelAd = useRef(false);
const navigate = useNavigate();
  // -----------------------------
  // Auto-scroll + highlight logic
  // -----------------------------
  // const scrollToCurrent = (ts) => {
  //   const items = descriptionRef.current.querySelectorAll(".desc-item");

  //   items.forEach((item) => item.classList.remove("active-desc"));

  //   const active = Array.from(items).find((x) => x.dataset.ts === ts);
  //   if (active) {
  //     active.classList.add("active-desc");
  //     active.scrollIntoView({ behavior: "smooth", block: "center" });
  //   }
  // };
const scrollToCurrent = (ts) => {
  if (!descriptionRef.current) return;

  const items = descriptionRef.current.querySelectorAll(".desc-item");

  items.forEach((item) => item.classList.remove("active-desc"));

  const active = Array.from(items).find((x) => x.dataset.ts === ts);

  if (active) {
    active.classList.add("active-desc");
    active.scrollIntoView({ behavior: "smooth", block: "center" });
  }
};
const startInlineEdit = (item) => {
  setEditingIndex(item.index);
  setEditedText(item.caption);
};

const saveInlineEdit = async (item) => {
  try {
    const payload = {
      index: item.index,
      caption: editedText,
      video_id: video.id
    };

    const res = await fetch("/api/update-description", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    });

    if (!res.ok) throw new Error("Failed");

    setEditingIndex(null);

    // ✅ Refresh page / reload data
    window.location.reload();

  } catch (err) {
    console.error("Update failed", err);
   // alert("Failed to update description");
  }
};

  // -----------------------------------------------
  // NEW: Convert HH:MM:SS.xx → seconds (any format)
  // -----------------------------------------------
  const tsToSeconds = (ts) => {
    const parts = ts.split(":"); // ["00","00","05.87"]

    if (parts.length === 3) {
      const h = Number(parts[0]);
      const m = Number(parts[1]);
      const s = Number(parts[2]);
      return h * 3600 + m * 60 + s;
    }

    if (parts.length === 2) {
      const m = Number(parts[0]);
      const s = Number(parts[1]);
      return m * 60 + s;
    }

    return Number(ts);
  };

 

const buildFinalTimeline = (descriptions = []) => {
  const finalTimeline = [];
  let cumulativeOffset = 0.0;

  descriptions.forEach((d, index) => {
    const origEnd = d.end;
    const audioDur = d.duration ?? 0;

    const finalEnd = origEnd + cumulativeOffset;

    const audioStart = finalEnd;

    finalTimeline.push({
      index,
      audio_start: audioStart,
      caption: d.caption,
     // audio_url: d.audio_url, 
      audio_url: d.audio_url
  ? `${BASE_URL}${d.audio_url}`
  : null

    });

    cumulativeOffset += audioDur;
  });

  return finalTimeline;
};

// const onTimeUpdate = () => {
//   if (!videoRef.current || !video?.descriptions) return;

//   const current = videoRef.current.currentTime;
//   const timeline = buildFinalTimeline(video.descriptions);

//   timeline.forEach((item) => {
//     const formatted = new Date(item.audio_start * 1000)
//       .toISOString()
//       .substring(11, 23);

//     if (
//       current >= item.audio_start - 0.5 &&
//       current <= item.audio_start + 0.5
//     ) {
//       scrollToCurrent(formatted);
//     }
//   });
// };
const playedIndexes = useRef(new Set());
const onTimeUpdate = () => {
  if (!videoRef.current || !video?.descriptions) return;

  const current = videoRef.current.currentTime;
  const timeline = buildFinalTimeline(video.descriptions);

  timeline.forEach((item) => {
    const formattedTS = new Date(item.audio_start * 1000)
      .toISOString()
      .substring(11, 23);

    // Highlight
    if (
      current >= item.audio_start - 0.2 &&
      current <= item.audio_start + 0.5
    ) {
      scrollToCurrent(formattedTS);
    }

    // ✅ PLAY AUDIO (FIXED)
    if (
      current >= item.audio_start - 0.2 &&
      current <= item.audio_start + 0.5 &&
      !playedIndexes.current.has(item.index) &&
      !isPlayingAd.current
    ) {
      //playAudioDescription(item);
    }
  });
};
const onTimeUpdate1 = () => {
  if (!videoRef.current || !video?.descriptions) return;

  const current = videoRef.current.currentTime;
  const timeline = buildFinalTimeline(video.descriptions);

  timeline.forEach((item) => {
    const formattedTS = new Date(item.audio_start * 1000)
      .toISOString()
      .substring(11, 23);

    // ✅ ADD THIS → highlight logic
    if (
      current >= item.audio_start - 0.3 &&
      current <= item.audio_start + 0.3
    ) {
      scrollToCurrent(formattedTS);
    }

    // existing audio logic
    // if (
    //   current >= item.audio_start &&
    //   current < item.audio_start + 0.3 &&
    //   !playedIndexes.current.has(item.index) &&
    //   !isPlayingAd.current
    // ) {
    //   playAudioDescription(item);
    // }

// if (
//   current >= item.audio_start &&
//   current < item.audio_start + 0.3 &&
//   !playedIndexes.current.has(item.index) &&
//   !isPlayingAd.current &&
//   !isUserPlaying.current   // ✅ IMPORTANT
// ) {
//   playAudioDescription(item);
// }
if (
  current >= item.audio_start &&
  current < item.audio_start + 0.3 &&
  !playedIndexes.current.has(item.index) &&
  !isPlayingAd.current 
  //&&
  //!isUserPlaying.current   // ✅ THIS LINE FIXES YOUR ISSUE  
) {
  playAudioDescription(item);
}
  });
};
// const onTimeUpdate = () => {
//   if (!videoRef.current || !video?.descriptions) return;

//   const current = videoRef.current.currentTime;
//   const timeline = buildFinalTimeline(video.descriptions);

//   timeline.forEach((item) => {
//     if (
//       current >= item.audio_start &&
//       current < item.audio_start + 0.3 &&
//       !playedIndexes.current.has(item.index) &&
//       !isPlayingAd.current
//     ) {
//       playAudioDescription(item);
//     }
//   });
// };
// const playAudioDescription = (item) => {
//   if (!videoRef.current) return;

//   isPlayingAd.current = true;
//   playedIndexes.current.add(item.index);

//   // ⏸ Pause video
//   videoRef.current.pause();

//   // 🎧 Create audio
//   const audio = new Audio(item.audio_url);
//   audioRef.current = audio;

//   audio.play();

//   audio.onended = () => {
//     isPlayingAd.current = false;

//     // ▶ Resume video
//     videoRef.current.play();
//   };
// };
const playAudioDescription = async (item) => {
  if (!videoRef.current) return;

  // stop previous audio safely
  if (audioRef.current) {
    audioRef.current.pause();
    audioRef.current = null;
  }

  isPlayingAd.current = true;
  playedIndexes.current.add(item.index);

  videoRef.current.pause();

  const audio = new Audio(item.audio_url);
  audioRef.current = audio;

  try {
    await audio.play();
  } catch (err) {
    // ✅ IGNORE AbortError (normal in race cases)
    if (err.name === "AbortError") return;

    console.error("Audio play failed:", err);
    return;
  }

  audio.onended = () => {
    isPlayingAd.current = false;

    if (videoRef.current) {
      videoRef.current.play().catch(() => {});
    }
  };
};
// const playAudioDescription = async (item) => {
//   if (!videoRef.current) return;

//   if (audioRef.current) {
//     audioRef.current.pause();
//     audioRef.current = null;
//   }

//   isPlayingAd.current = true;
//   playedIndexes.current.add(item.index);

//   videoRef.current.pause();
//   videoRef.current.currentTime = item.audio_start; // ✅ stabilize

//   const audio = new Audio(item.audio_url);
//   audioRef.current = audio;

//   try {
//     await audio.play();
//   } catch (err) {
//     console.error("Audio play failed:", err);
//     return;
//   }

//   audio.onended = () => {
//     isPlayingAd.current = false;

//     if (videoRef.current) {
//       videoRef.current.play().catch(() => {});
//     }
//   };
// };
// const playAudioDescription = async (item) => {
//   if (!videoRef.current) return;

//   cancelAd.current = false;

//   // stop old audio
//   if (audioRef.current) {
//     audioRef.current.pause();
//     audioRef.current = null;
//   }

//   isPlayingAd.current = true;
//   playedIndexes.current.add(item.index);

//   videoRef.current.pause();

//   const audio = new Audio(item.audio_url);
//   audioRef.current = audio;

//   try {
//     await audio.play();

//     // 🚨 If user clicked play while audio was starting
//     if (cancelAd.current) {
//       audio.pause();
//       return;
//     }

//   } catch (err) {
//     if (err.name !== "AbortError") {
//       console.error("Audio play failed:", err);
//     }
//     return;
//   }

//   audio.onended = () => {
//     isPlayingAd.current = false;

//     if (!cancelAd.current && videoRef.current) {
//       videoRef.current.play().catch(() => {});
//     }
//   };
// };
const playAudioDescriptioncorect = async (item) => {
  if (!videoRef.current) return;

  // stop existing audio
  if (audioRef.current) {
    audioRef.current.pause();
    audioRef.current = null;
  }

  isPlayingAd.current = true;
  playedIndexes.current.add(item.index);

  videoRef.current.pause();

  const audio = new Audio(item.audio_url);
  audioRef.current = audio;

  try {
    await audio.play();  // ✅ await prevents race crash
  } catch (err) {
    if (err.name !== "AbortError") {
      console.error("Audio play failed:", err);
    }
    return;
  }

  audio.onended = () => {
    isPlayingAd.current = false;

    if (videoRef.current && !isUserPlaying.current) {
      videoRef.current.play().catch(() => {});
    }
  };
};

const playAudioDescription1 = (item) => {
  if (!videoRef.current) return;

  // stop any existing AD
  if (audioRef.current) {
    audioRef.current.pause();
    audioRef.current = null;
  }

  isPlayingAd.current = true;
  playedIndexes.current.add(item.index);

  // ✅ FORCE pause video
  videoRef.current.pause();

  const audio = new Audio(item.audio_url);
  audioRef.current = audio;

  audio.play().catch((err) => {
    console.error("Audio play failed:", err);
  });

  audio.onended = () => {
    isPlayingAd.current = false;

    // ✅ resume video AFTER AD
    if (videoRef.current) {
      videoRef.current.play().catch(() => {});
    }
  };
};
// const playAudioDescription = (item) => {
//   if (!videoRef.current) return;

//   // 🚫 If user is already playing video → skip AD
//   if (!videoRef.current.paused) {
//     return;
//   }

//   if (audioRef.current) {
//     audioRef.current.pause();
//   }

//   isPlayingAd.current = true;
//   playedIndexes.current.add(item.index);

//   videoRef.current.pause();

//   const audio = new Audio(item.audio_url);
//   audioRef.current = audio;

//   audio.play().catch((err) => {
//     console.error("Audio play failed:", err);
//   });

//   audio.onended = () => {
//     isPlayingAd.current = false;

//     if (videoRef.current) {
//       videoRef.current.play().catch(() => {});
//     }
//   };
// };

// const playAudioDescription = (item) => {
//   if (audioRef.current) {
//   audioRef.current.pause();
// }
//   if (!videoRef.current) return;

//   isPlayingAd.current = true;
//   playedIndexes.current.add(item.index);

//   videoRef.current.pause();

//   const audio = new Audio(item.audio_url);
//   console.log("Playing audio:", item.audio_url);
//   audioRef.current = audio;

//   audio.play().catch((err) => {
//     console.error("Audio play failed:", err);
//   });

//   audio.onended = () => {
//     isPlayingAd.current = false;

//     if (videoRef.current) {
//       videoRef.current.play().catch(() => {});
//     }
//   };
// };

// const onSeeked = () => {
//   playedIndexes.current.clear();
//   isPlayingAd.current = false;

//   if (audioRef.current) {
//     audioRef.current.pause();
//   }
// };
// const onSeeked = () => {
//   playedIndexes.current.clear();
//   isPlayingAd.current = false;
//   isUserPlaying.current = false;

//   if (audioRef.current) {
//     audioRef.current.pause();
//   }
// };
const onSeeked = () => {
  playedIndexes.current.clear();
  isPlayingAd.current = false;
  isUserPlaying.current = false;  // ✅ reset

  if (audioRef.current) {
    audioRef.current.pause();
  }
};
// useEffect(() => {
//   if (!videoRef.current) return;

//   videoRef.current.ontimeupdate = onTimeUpdate;
//   videoRef.current.onseeked = onSeeked;
// }, [video]);

  // useEffect(() => {
  //   if (!videoRef?.current) return;
  //   videoRef.current.ontimeupdate = onTimeUpdate;
  // }, [videoRef, video]);
  useEffect(() => {
  const videoEl = videoRef.current;
  if (!videoEl) return;

  // const handlePlay = () => {
  //   console.log("User played video ✅");

  //   cancelAd.current = true;
  //   isUserPlaying.current = true;

  //   if (audioRef.current) {
  //     audioRef.current.pause();
  //     audioRef.current.currentTime = 0;
  //     audioRef.current = null;
  //   }

  //   isPlayingAd.current = false;
  // };
const handlePlay = () => {
  console.log("User played video");

  // Only stop if audio is already playing
  if (isPlayingAd.current && audioRef.current) {
    audioRef.current.pause();
    audioRef.current = null;
    isPlayingAd.current = false;
  }

  isUserPlaying.current = true;
};
  const handlePause = () => {
    console.log("Video paused");

    isUserPlaying.current = false;

    if (isPlayingAd.current) return;

    if (audioRef.current && !audioRef.current.paused) {
      audioRef.current.pause();
    }
  };

  const handleTimeUpdate = () => onTimeUpdate1();
  const handleSeeked = () => onSeeked();

  // ✅ Attach events properly
  videoEl.addEventListener("play", handlePlay);
  videoEl.addEventListener("pause", handlePause);
  videoEl.addEventListener("timeupdate", handleTimeUpdate);
  videoEl.addEventListener("seeked", handleSeeked);

  return () => {
    videoEl.removeEventListener("play", handlePlay);
    videoEl.removeEventListener("pause", handlePause);
    videoEl.removeEventListener("timeupdate", handleTimeUpdate);
    videoEl.removeEventListener("seeked", handleSeeked);
  };
}, [video]); // ✅ re-run when video changes
// useEffect(() => {
//   if (!videoRef.current) return;

//   const video = videoRef.current;



//   // video.addEventListener("click", handleUserInteraction);
//   // video.addEventListener("keydown", handleUserInteraction);

 

//   // video.onpause = () => {
//   //   if (audioRef.current && !audioRef.current.paused) {
//   //     audioRef.current.pause();
//   //   }
//   // };
// // video.onpause = () => {
// //   // ❌ Don't pause audio if we triggered it
// //   if (isPlayingAd.current) return;

// //   if (audioRef.current && !audioRef.current.paused) {
// //     audioRef.current.pause();
// //   }
// // };
// //   video.onplay = () => {
// //   // ✅ If user plays video manually → stop AD
// //   if (audioRef.current && !audioRef.current.paused) {
// //     audioRef.current.pause();
// //     audioRef.current = null;
// //   }

// //   isPlayingAd.current = false; // reset flag
// // };
// video.onpause = () => {


//   isUserPlaying.current = false;

//   if (isPlayingAd.current) return;

//   if (audioRef.current && !audioRef.current.paused) {
//     audioRef.current.pause();
//   }
// };
// // video.onplay = () => {
// //   // 🚨 If AD is playing → STOP it immediately
// //   if (isPlayingAd.current) {
// //     video.pause(); // 🚫 block video while AD
// //   }
// //   if (isPlayingAd.current && audioRef.current) {
// //     console.log("User played video → stopping AD");

// //     audioRef.current.pause();
// //     audioRef.current.currentTime = 0;
// //     audioRef.current = null;

// //     isPlayingAd.current = false;
// //   }
// // };
// // video.onplay = () => {
// //   console.log("User started video");

// //   isUserPlaying.current = true;   // ✅ mark user action

// //   // ✅ Stop AD immediately
// //   // if (audioRef.current) {
// //   //   audioRef.current.pause();
// //   //   audioRef.current.currentTime = 0;
// //   //   audioRef.current = null;
// //   // }

// //   isPlayingAd.current = false;
// // };


// video.onplay = () => {
//   console.log("User played video");

//   cancelAd.current = true;   // ✅ mark cancellation
//   isUserPlaying.current = true;

//   if (audioRef.current) {
//     audioRef.current.pause();
//     audioRef.current.currentTime = 0;
//     audioRef.current = null;
//   }

//   isPlayingAd.current = false;
// };




// video.onplaycorect = () => {
//   isUserPlaying.current = true;

//   if (audioRef.current) {
//     audioRef.current.pause();
//     audioRef.current.currentTime = 0;
//     audioRef.current = null;
//   }

//   isPlayingAd.current = false;
// };
// // video.onplay = () => {
// //   // user action
// //   isUserPlaying.current = true;

// //   if (audioRef.current && !audioRef.current.paused) {
// //     audioRef.current.pause();
// //     audioRef.current = null;
// //   }

// //   isPlayingAd.current = false;
// // };

// }, []);
useEffect(() => {
  if (!videoRef.current) return;

  const video = videoRef.current;

  const handleUserInteraction = () => {
    // 🚨 Stop AD immediately
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
      audioRef.current = null;
    }

    isPlayingAd.current = false;
  };

  // video.addEventListener("click", handleUserInteraction);
  // video.addEventListener("play", handleUserInteraction);

  return () => {
    video.removeEventListener("click", handleUserInteraction);
    video.removeEventListener("play", handleUserInteraction);
  };
}, []);
useEffect(() => {
  return () => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current = null;
    }
  };
}, []);

useEffect(() => {
  if (audioRef.current) {
    audioRef.current.pause();
  }
});


  const jumpTo = (ts) => {
    if (!videoRef.current) return;
    const s = tsToSeconds(ts);
    videoRef.current.currentTime = s;
    videoRef.current.play();
  };
const deleteDescription = async (item) => {
  if (!window.confirm("Delete this description?")) return;

  await fetch(`/api/delete-description/${item.index}`, {
    method: "DELETE"
  });

  window.location.reload();
};

  console.log("video in audioredwscribevideo page,",video)
  return (
  <Card className="video-card shadow-sm border-1" role="region" aria-labelledby="video-title">


  {/* Video Title */}
 
<div
    className="video-title-videodiv"
    id="video-title"
    aria-live="polite"
  >
    {videoname}
  </div>
  {/* Tabs */}
  {/* <Nav
    variant="pills"
    activeKey={activeTab}
    // onSelect={(key) => setActiveTab(key)}
    className="video-tabs"
     role="tablist"
    aria-label="Video type tabs"
  >

    <Nav.Item>
     
      <Nav.Link
        eventKey="described"
        disabled={!video?.output_download_url}
          role="tab"
        aria-selected={activeTab === "described"}
        aria-controls="described-video-panel"
      >
        Audio Described
        {video?.video_status === "in progress" && (
          <i className="bi bi-hourglass-split ms-1 text-warning" 
          aria-label="Video processing in progress"
            role="img"></i>
        
        )}
        {video?.video_status === "failed" && (
          <ExclamationTriangleFill
            size={14}
            color="red"
            className="ms-1"
            aria-label="Video processing failed"

          />
        )}
      </Nav.Link>
    </Nav.Item>

    <Nav.Item>
      <Nav.Link eventKey="original"  role="tab"
        aria-selected={activeTab === "original"}
        aria-controls="original-video-panel" >
         Original Video
      </Nav.Link>
      
    </Nav.Item>


  </Nav> */}

  {/* Video Container */}
  
  <div className="video-container">
    {/* {activeTab === "described" && video?.output_download_url && (

       <div
        id="described-video-panel"
        role="tabpanel"
        aria-labelledby="described-tab"
      >
      <video
        ref={videoRef}
        src={video.output_download_url}
        controls
        className="video-player"
         aria-label={`Audio described video: ${videoname}`}
      tabIndex="0"
      />



      </div>
    )} */}

    {/* <AudioDescriptionEdit videoRef={videoRef} /> */}

 
    {/* <AudioDescriptionEdit  videoUrl={video?.output_download_url }
  descriptions={video?.descriptions} /> */}

    {/* {activeTab === "original" && originalVideoUrl && (
      <div
        id="original-video-panel"
        role="tabpanel"
        aria-labelledby="original-tab"
      >
      <video
        ref={videoRef}
        src={originalVideoUrl}
        controls
        className="video-player"
        tabIndex="0"
         aria-label={`Original video: ${videoname}`}
      />

      
       </div>
       
    )} */}

  {originalVideoUrl && (
    <div
      id="original-video-panel"
      role="tabpanel"
      aria-labelledby="original-tab"
    >
      <video
        // ref={videoRef}
        // src={originalVideoUrl}
           ref={videoRef}
        src={video.output_download_url}
        controls
        className="video-player"
        tabIndex="0"
        aria-label={`Original video: ${videoname}`}
      />
    </div>
  )}
</div>
 

  {/* Descriptions */}
  {/* {video?.output_download_url && video?.descriptions?.length > 0 && ( */}
      {video?.descriptions?.length > 0 && (

    <div ref={descriptionRef} className="description-box" 
     role="list"
      aria-label="Video description timeline">
      {/* {buildFinalTimeline(video.descriptions).map((item) => {
        const formattedTS = new Date(item.audio_start * 1000)
          .toISOString()
          .substring(11, 23);

        return (
          <div
            key={item.index}
            className="desc-item"
            data-ts={formattedTS}
            onClick={() => jumpTo(formattedTS)}
          >
            <span className="desc-time">{formattedTS}</span>
            <span className="desc-text">{item.caption}</span>
          </div>
        );
      })} */}
      {buildFinalTimeline(video.descriptions)
  .filter(item => item.caption && item.caption.trim() !== "")
  .map((item) => {
    const formattedTS = new Date(item.audio_start * 1000)
      .toISOString()
      .substring(11, 23);

    return (
    
      //    <div
      //         key={item.index}
      //         className="desc-item"
      //         role="listitem"
      //         tabIndex="0"
      //         data-ts={formattedTS}
      //         aria-label={`Jump to ${formattedTS}. ${item.caption}`}
      //         onClick={() => jumpTo(formattedTS)}
      //         onKeyDown={(e) => {
      //           if (e.key === "Enter" || e.key === " ") {
      //             e.preventDefault();
      //             jumpTo(formattedTS);
      //           }
      //         }}
      //       >
      //   <span className="desc-time" aria-hidden="true">{formattedTS}</span>
      //   <span className="desc-text">{item.caption}</span>
      // </div>
<div
  key={item.index}
  className="desc-item"
  role="listitem"
  tabIndex="0"
  data-ts={formattedTS}
>
  <div
    className="desc-main"
    // onClick={() => jumpTo(formattedTS)}
    onClick={(e) => {
    if (window.getSelection().toString()) return; // ✅ allow text select
    jumpTo(formattedTS);
  }}
    onKeyDown={(e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        jumpTo(formattedTS);
      }
    }}
  >
    <span className="desc-time">{formattedTS}</span>
    <span className="desc-text">{item.caption}</span>
  
{/* {isExpert ? (
  editingIndex === item.index ? (
  
   
<input
  className="inline-edit-input"
  autoFocus
  value={editedText}
  onChange={(e) => setEditedText(e.target.value)}

  onKeyDown={(e) => {
    e.stopPropagation(); // ✅ allows SPACE typing

    if (e.key === "Enter") {
      saveInlineEdit(item);
    }
    if (e.key === "Escape") {
      setEditingIndex(null);
    }
  }}

  onBlur={() => saveInlineEdit(item)}
/>


  ) : (
    <span className="desc-text">{item.caption}</span>
  )
) : (
  <span className="desc-text">{item.caption}</span>
)} */}

  </div>

  {/* ✏️ 🗑️ Actions */}
  {/* <div className="desc-actions">
    <button
      className="icon-btn edit"
      title="Edit description"
      onClick={(e) => {
        e.stopPropagation();
        console.log("Edit", item);
      }}
    >
      ✏️
    </button>

    <button
      className="icon-btn delete"
      title="Delete description"
      onClick={(e) => {
        e.stopPropagation();
        console.log("Delete", item);
        // TODO: delete logic
      }}
    >
      🗑️
    </button>
  </div> */}
{/* {isExpert && (
  <div className="desc-actions">
    <button
  className="icon-btn edit"
  onClick={(e) => {
    e.stopPropagation();
    startInlineEdit(item);
  }}
>
  ✏️
</button>

    <button
  className="icon-btn delete"
  onClick={(e) => {
    e.stopPropagation();
    deleteDescription(item);
  }}
>
  🗑️
</button>

  </div>
)} */}


</div>

      
    );
  })}

    </div>



  )
  }




   {/* <AudioDescriptionEdit
  videoSrc={
    activeTab === "described"
      ? video?.output_download_url
      : originalVideoUrl
  }
/> */}





</Card>



//     <Card className="shadow-sm border-0 p-3 card-bgcolor">
//  <div className="mb-2"
//                 style={{
                
//                   fontSize: "0.95rem",
//                   fontWeight: 600,
//                   color: "#333",
//                  // whiteSpace: "nowrap",
//                 //  overflow: "hidden",
//                   //textOverflow: "ellipsis",
//                   width: "100%",
//                       textAlign: "center",   // ✅ center text

//                 }}
//                 title={videoname}
//               >
// {videoname}
//               </div>

//       <Nav
//         variant="tabs"
//         activeKey={activeTab}
//         onSelect={(key) => setActiveTab(key)}
//         className="custom-tabs small-tabs"
//       >
//         <Nav.Item>
//           <Nav.Link eventKey="described" disabled={!video?.output_download_url}>
//             Audio Described Video
//             {video?.video_status === "in progress" && (
//               <i
//                 className="bi bi-hourglass-split"
//                 style={{
//                   color: "#FFD700",
//                   marginLeft: "4px",
//                   animation: "spin 1s linear infinite",
//                 }}
//               ></i>
//             )}
//             {video?.video_status === "failed" && (
//               <ExclamationTriangleFill
//                 size={16}
//                 color="red"
//                 style={{ marginLeft: "4px" }}
//               />
//             )}
//           </Nav.Link>
//         </Nav.Item>

//         <Nav.Item>
//           <Nav.Link eventKey="original">Uploaded Video</Nav.Link>
//         </Nav.Item>
//       </Nav>

//       <div className="video-wrapper-small">
//         {activeTab === "described" && video?.output_download_url && (
//           <video
//             ref={videoRef}
//           src={video.output_download_url}
//             controls
//             className="responsive-video-small"
//           />

    
//         )}

//         {activeTab === "original" && originalVideoUrl && (
//           <video
//             ref={videoRef}
//            src={originalVideoUrl}
//             controls
//             className="responsive-video-small"
//           />
//         )}
//       </div>


// {video?.output_download_url && video?.descriptions?.length > 0 && (

//       <div
//         ref={descriptionRef}
//         style={{
//           marginTop: "10px",
//           background: "#fff",
//           borderRadius: "8px",
//           maxHeight: "120px",
//           overflowY: "auto",
//           padding: "10px",
//         }}
//       >

// {video?.descriptions &&
//   buildFinalTimeline(video.descriptions).map((item) => {
//     const formattedTS = new Date(item.audio_start * 1000)
//       .toISOString()
//       .substring(11, 23);

//     return (
//       <div
//         key={item.index}
//         className="desc-item"
//         data-ts={formattedTS}
//         onClick={() => jumpTo(formattedTS)}
//         style={{
//           display: "flex",
//           cursor: "pointer",
//           padding: "6px 8px",
//           borderRadius: "6px",
//           marginBottom: "4px",
//         }}
//       >
//         <span
//           style={{
//             color: "#0d6efd",
//             fontWeight: "bold",
//             minWidth: "95px",
//             display: "inline-block",
//             fontSize: "0.85rem",
//           }}
//         >
//           {formattedTS}
//         </span>

//         <span style={{ flex: 1, fontSize: "0.9rem", color: "#333" }}>
//           {item.caption}
//         </span>
//       </div>
//     );
//   })}

//       </div>
// )}
//       <style>{`
//         .desc-item.active-desc {
//             background: #e9f2ff;
//             border-left: 4px solid #0d6efd;
//         }
//       `}</style>
//     </Card>




  );
};

export default AudioRedescribeVideo;
